import React, { Component } from 'react';
import { connect } from 'react-redux';

import { EMBED_UPDATE_TIME } from 'constants/messages';
import {
  MIN_TRIM_RANGE_LENGTH,
  TRIM_BOUND_LOWER,
  TRIM_BOUND_UPPER,
} from 'constants/trimming';
import {
  updateCurrentTrimRangeCreator,
  updateSelectedTrimBoundCreator,
} from 'creators/trimming';
import { getBoundingRange, getNewTrimBoundTime } from 'utilities/trimming';

import TrimPill, { LEFT_HALF, RIGHT_HALF } from './trim-pill';

import './styles.less';

class TrimRangePillBar extends Component {
  boundingRange = getBoundingRange(
    this.props.currentTrimRange,
    this.props.trimRanges,
    this.props.duration * 1000
  );

  render() {
    const { currentTrimRange, selectedTrimBound } = this.props;

    const leftFlagMax = currentTrimRange.to - MIN_TRIM_RANGE_LENGTH;
    const leftFlagMin = this.boundingRange.from;

    const rightFlagMax = this.boundingRange.to;
    const rightFlagMin = currentTrimRange.from + MIN_TRIM_RANGE_LENGTH;

    const leftPillActive = selectedTrimBound === TRIM_BOUND_LOWER;
    const rightPillActive = selectedTrimBound === TRIM_BOUND_UPPER;

    return (
      <div className="trim-range-pill-bar">
        <TrimPill
          time={currentTrimRange.from}
          active={leftPillActive}
          half={LEFT_HALF}
          max={leftFlagMax}
          min={leftFlagMin}
          onTimeChange={this.onPillTimeChange}
          updateSelectedTrimBoundCreator={
            this.props.updateSelectedTrimBoundCreator
          }
        />
        <span className="divider" />
        <TrimPill
          time={currentTrimRange.to}
          active={rightPillActive}
          half={RIGHT_HALF}
          max={rightFlagMax}
          min={rightFlagMin}
          onTimeChange={this.onPillTimeChange}
          updateSelectedTrimBoundCreator={
            this.props.updateSelectedTrimBoundCreator
          }
        />
      </div>
    );
  }

  onPillTimeChange = (half, newTime) => {
    const currentTrimRange = { ...this.props.currentTrimRange };

    const isLeftFlag = half === LEFT_HALF;

    const newCurrentTime = getNewTrimBoundTime(
      newTime,
      currentTrimRange,
      this.boundingRange,
      isLeftFlag,
      MIN_TRIM_RANGE_LENGTH
    );

    if (isLeftFlag) {
      currentTrimRange.from = newCurrentTime;
    } else {
      currentTrimRange.to = newCurrentTime;
    }

    this.props.updateCurrentTrimRangeCreator(currentTrimRange);
    window.top.postMessage(
      {
        type: EMBED_UPDATE_TIME,
        numSeconds: newCurrentTime / 1000,
      },
      '*'
    );
  };
}

const mapStateToProps = state => {
  const {
    current_trim_range: currentTrimRange,
    selected_trim_bound: selectedTrimBound,
    trim_ranges: trimRanges,
  } = state.trimming;

  return { currentTrimRange, selectedTrimBound, trimRanges };
};

const mapDispatchToProps = dispatch => {
  return {
    updateCurrentTrimRangeCreator: trimRange =>
      dispatch(updateCurrentTrimRangeCreator(trimRange)),
    updateSelectedTrimBoundCreator: trimBound =>
      dispatch(updateSelectedTrimBoundCreator(trimBound)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrimRangePillBar);
